import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ErrorEnum from 'model/ErrorEnum';
import ProfileInfoContext from 'storage/ProfileInfoContext';
import { renderAuthOutcome } from './renderAuthOutcome';

export default function withLegacyAuthRequired(Component) {
  function LegacyAuth(props) {
    const { authError, isAuth, isFetching, login } = props;

    useEffect(() => {
      if (isFetching) return;
      if (isAuth) return;
      if (authError && authError.name !== ErrorEnum.UNAUTHORIZED) return;
      login();
    }, [authError, isAuth, isFetching, login]);

    return renderAuthOutcome(Component, props);
  }

  LegacyAuth.propTypes = {
    authError: PropTypes.shape({ name: PropTypes.string }),
    isAuth: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    login: PropTypes.func.isRequired,
  };

  LegacyAuth.defaultProps = {
    authError: null,
  };

  return ProfileInfoContext.withContext(['authError', 'isAuth', 'isFetching', 'login'])(LegacyAuth);
}
